module.exports = __webpack_public_path__ + "img/bugoro_07.a51ef5d7.png";